export { default, type TPicturesProps } from "./Pictures";
